import { createContext } from 'react';

const firebaseContext = createContext();

export default firebaseContext;
